import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import CheckWrapper from 'assets/components/inputs/wrappers/CheckWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales, Language } from 'assets/locales/Locale';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import Icon from 'assets/components/icon/Icon';
import useApi from 'assets/hooks/api/useApi';
import productListApi from 'models/productManagement/product/list/Api.Product.List';
import { useEffect } from 'react';

const ContractAdjustDistributionsDocuments = () => {
  const { lang, translate } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();

  const productsApi = useApi({
    action: productListApi,
    wait: true,
  });

  const isSignable =
    !!productsApi.payload?.data
      ?.find((p) => p.id === (form.data?.productId ?? form.data?.product?.id))
      ?.productDocuments?.some((pd) => pd.signatureFields?.length) &&
    form.data?.product?.isSendDocumentToDocusignEnabled;

  useEffect(() => {
    productsApi.execute({ productId: form.data?.productId ? [form.data.productId] : [] });
  }, [form.data?.productId]);

  return (
    <FormWrapper>
      <SelectInput
        name="documentLanguageIsoCode"
        label={lang.language}
        data={Object.values(Language).map((val) => ({ id: val, title: translate(val) }))}
        value={form.data.documentLanguageIsoCode}
        onChange={form.update}
        icon={<Icon class="fas-language" />}
      />
      <CheckWrapper>
        <CheckInput
          name="generateDocuments"
          label={lang.generateDocuments}
          onChange={form.update}
          class={inputStyles.check.switch}
          value={form.data?.generateDocuments}
          htmlElementProps={{ title: form.data?.generateDocuments ? lang.disable : lang.enable }}
        />
        <CheckInput
          name="sendDocumentForSigning"
          label={lang.sendDocumentForSigning}
          onChange={form.update}
          class={inputStyles.check.switch}
          value={form.data?.sendDocumentForSigning}
          disabled={!isSignable}
          htmlElementProps={{ title: form.data?.sendDocumentForSigning ? lang.disable : lang.enable }}
        />
      </CheckWrapper>
    </FormWrapper>
  );
};

export default ContractAdjustDistributionsDocuments;
